import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Simulateur from './Simulateur';
import Footer from './components/Footer';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Legal from './pages/Legal';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <div className="App min-h-screen bg-gradient-to-b from-blue-50 to-gray-50 flex flex-col">
            <div className="flex-grow max-w-4xl mx-auto px-4 py-8 w-full">
              <Simulateur />
            </div>
            <Footer />
          </div>
        } />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/legal" element={<Legal />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;